import { render, staticRenderFns } from "./ShiftRequest.vue?vue&type=template&id=124a23cd&lang=pug&"
import script from "./ShiftRequest.vue?vue&type=script&lang=js&"
export * from "./ShiftRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports